<template>
    <div class="home">

        <pageheader :text="heading"/>

        <p>
            Bruk hurtigtastene eller skriv inn beløpet du ønsker å sette inn på spillekontoen din. Deretter bekrefter du vilkårene og trykker 'Overfør'.
        </p>

        <p class="d-lg-none">
            Se tidligere overføringer her: <router-link to="/transaksjoner">transaksjoner.</router-link>
        </p>


        <div class="text-center  my-2" v-if="!user">
            <b-spinner class="align-middle"></b-spinner>
            <strong> Laster...</strong>
        </div>
        <div v-else-if="user && !user.payment_available">
            <p>
                Du er logget inn for spill en annen plass. Du må avslutte før du kan sette inn penger.
            </p>

        </div>
        <div v-else-if="user && !user.hall.owner.payment_available">
            <p>
                Betaling er ikke tilgjengelig for din bingohall.
            </p>

        </div>
        <b-form @submit="onSubmit" v-else>

            <div class="form-group">

                <div class="mb-3">
                    <b-badge v-for="a in amounts" :key="a" @click="amountSelected(a)" href="#" class="transferAmount" variant="primary">{{a}},-</b-badge>
                </div>


                <b-input-group  prepend="kr" append=",-" class="w-50">
                    <input v-model="form.amount" type="number" number min="0" class="form-control" id="exampleInputEmail1" aria-describedby="emailHelp" placeholder="Beløp">
                </b-input-group>
            </div>

            <div class="payment-logos">
                <a href="https://vipps.no"><img alt="Vipps logo" src="@/assets/vipps.png"></a>
                <a href="https://nets.no"><img alt="Nets logo" src="@/assets/nets.png"></a>
                <a href="https://visa.no"><img alt="Visa logo" src="@/assets/visa.png"></a>
            </div>

            <hr>

            <div class="form-check mb-4">
                <input  v-model="form.acceptedTerms" type="checkbox" class="form-check-input" id="terms">
                <label class="form-check-label" for="terms">Jeg bekrefter <b-link variant="link" v-b-modal.termsModal>vilkårene</b-link></label>
            </div>

            <b-alert show variant="danger" v-if="errors.length" class="errors">

                <ul>
                    <li  v-for="error in errors" :key="error">
                        {{ error }}
                    </li>
                </ul>


            </b-alert>

            <loading-button :disabled="formDisabled" >
                Overfør
            </loading-button>

        </b-form>


        <b-modal id="termsModal" centered size="lg" title="Betalingsvilkår">

            <h2>Hvordan fyller du på spillekontoen din?</h2>
            <p>
                For å kunne spille på nett må du ha tilgjengelig kreditt på
                spillekontoen din. Dette kan gjøres lokalt på den bingoen
                du opprettet medlemskap på, eller inne på norskbingo.no
                med visa, mastercard eller vipps.
            </p>

            <h2>Angrerett på innsatt beløp til spillekonto!</h2>
            <p>
                Tilgjengelig beløp på din spillekonto kan når som helst tas
                ut  igjen ved å oppsøke den bingoen du har medlemskap
                og spillekonto hos. Det er ingen krav til å måtte spille noe
                av den kreditten som er satt inn på spillekontoen.
            </p>


            <h2>Angrerett på kjøp av spillebonger!</h2>
            <p>
                Kjøpte bonger kan angres helt frem til spillet har startet
                ved å trykke avbryt kjøp. Kjøpet er ikke avbrutt dersom
                kjøpte bonger ikke er fjernet fra skjermen og pengene
                returnert til spillekonto.
            </p>

            <h2>Blokker deg for spill!</h2>
            <p>
                Du kan når som helst blokkere deg selv ute fra spill på
                vår nettside. Hvis du tar dette valget vil du være
                utestengt for spill for 1 år. Du kan fortsatt gå til den
                bingoen du har medlemskap på, å ta ut tilgjengelig
                kreditt på din spillekonto. Ved å stenge deg ute fra
                nettspill hindrer deg ikke i å spille hos din lokale bingo.
            </p>
        </b-modal>



    </div>
</template>

<script>

// @ is an alias to /src
import LoadingButton from '@/components/LoadingButton.vue';

export default {
    name: 'Transfer',
    components: {
        LoadingButton
    },
    data() {
        return {
            user: null,
            amounts: [
                100,
                200,
                500,
                1000,
                2000
            ],
            form: {
                amount: null,
                acceptedTerms: false
            },
            errors:[],
            formDisabled: false
        }
    },

    mounted() {
        // Get user data
        this.$api.get(`/users/${this.$store.getUser().card_id}/`)
        .then((response) => {
            // Fil form
            this.user = response.data.data
        })
        .catch((response) => {
            console.log(response);
        });

    },


    methods: {
        amountSelected(amount) {
            this.form.amount = amount
        },
        onSubmit(e) {
            e.preventDefault()


            this.errors = []

            if (!this.form.amount) this.errors.push('Verdi mangler.')
            if (this.form.amount <= 0) this.errors.push('Verdi må være positiv.')
            if (this.form.amount < 50) this.errors.push('Minimumsverdi er 50m,-')
            if (!this.form.acceptedTerms) this.errors.push('Du må akseptere vilkårene.')

            if (this.errors.length) return;


            this.formDisabled = true

            var postData = {
                amount: this.form.amount,
                redirect_url: process.env.VUE_APP_FULL_BASE_URL + "/overforing/behandler/"
            };

            this.$api.post(`/users/${this.$store.getUser().card_id}/payments/`, postData)
            .then((response) => {

                let terminalUrl = response.data.terminal_url;

                window.location = terminalUrl;

            })
            .catch((error) => {
                if (error.response) {
                    let code = error.response.status;

                    if (code == 409) {
                        this.errors.push('Du er logget inn for spill en annen plass. Du må avslutte før du kan sette inn penger.')
                    }
                    else if (code == 500) {
                        this.errors.push('Vi kunne ikke registrere betalingen din via Nets.')
                    }
                    else {
                        this.errors.push('En ukjent feil har oppstått. Kontakt support.')
                    }
                }
                this.formDisabled = false
            });


        },
    },
    computed: {
        heading:  function() {
            if (this.user) return `Sett inn penger hos ${this.user.hall.owner.name} (${this.user.hall.owner.orgnum})`;
            else return "Sett inn penger hos ...";
        }
    }
}

</script>


<style lang="scss">

.transferAmount {
    font-size: 1.5em;
    margin-right: 0.5em;
    margin-top: 0.5em;
}
.errors {
    font-size: 0.8em;
    margin-top: 2em;
}
.errors ul {
    margin-bottom: 0;
    padding-left: 0;
    list-style: none;
}
.payment-logos img {
    width: auto;
    height: 20px;
    margin-right: 10px;
}

#termsModal h2 {
    font-size: 1.2em;

}

</style>
